<template>
    <!--
    Wrapper for sidebar content.
    Adds specific class for different sidebar styles/behaviour.

    @property {String} type
    @property {String} position
    @property {String} mainContentTab
    -->
    <aside class="sidebar" :class="{
        'sidebar--tabs': type == 'tabs',
        'sidebar--fixed': type == 'fixed',
        'sidebar--flex': type == 'flex',

        'top': position == 'top' && type == 'flex',
        'bottom': position == 'bottom' && type == 'flex',
    }" v-if="type">

        <slot />

    </aside>
</template>

<script>
import { mapState } from 'vuex';

export default
{
    name: 'Sidebar',

    props: {
        'type': {
            type: String,
        },
        'position': {
            type: String,
        },
        'mainContentTab': {
            type: Boolean,
            default: false,
        },
    },

    mounted() {
        this.$store.dispatch('sidebar/mainContentTab', this.mainContentTab);
        this.$store.dispatch('sidebar/setPosition', this.position);
        this.$store.dispatch('sidebar/setType', this.type);
    },

    /**
     * Reset sidebar settings to its default values
     */
    beforeDestroy() {
        this.$store.dispatch('sidebar/reset');
    }
}
</script>



// WEBPACK FOOTER //
// Sidebar.vue?3d7c30b0